import styled, { css } from "styled-components";

export const Container = styled.aside`
  display: flex;
  flex-direction: column;
  align-items: center;

  background: ${(props) => props.color ? props.color : "var(--main-color)"};
  color: var(--grey-soft);

  min-height: 100vh;
  height: 100%;

  width: var(--sidebar-width);

  @media print{
    display: none;
  }

  svg, img, button, span.span-of-component-button{
    max-width: 100%;
  }
`;

export const MenuTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid rgba(255,255,255,0.2);
  
  img.home-page-icon{
    width: 32px;
    height: 32px;
  }
  button{
    padding: 0.25rem;
    width: 100%;
  }
`;

export const DivRenderMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  width: 100%;

  >div >button{
    padding: 0.25rem 0.125rem;
    width: 100%;
  }

  @media(max-height: 792px){
    span.span-of-component-button >svg{
      width: 1.25rem;
      height: 1.25rem;
    }
  }
  @media(max-height: 732px){
    >div >button{
      margin: 0;
    }
  }
  @media(max-height: 676px){
    >div >button{
      padding: 0.125rem;
    }
  }
  
  small{
    display: flex;
    line-height: 0.6rem;
    font-size: 0.6rem;
    color: var(--grey-soft);
    user-select: none;
    overflow: hidden;
    @media(max-height: 630px){
      line-height: 0.5rem;
      font-size: 0.55rem;
    }
  }
  @media(max-height: 606px){
    justify-content: space-evenly;
    small{
      display: none;
    }
  }
`;

interface IMenuItemChilds{
  bottom?: boolean;
  selfEnclose?: boolean;
}

export const MenuItemChilds = styled.div<IMenuItemChilds>`
  position: absolute;
  ${(props) => props.bottom ? css`
    bottom: 0;
  ` : css`
    top: 0;
  `}
  left: -0.125rem;
  z-index: 202;
  background: var(--input-background-color);
  border: 1px solid var(--border-color);
  min-width: 14rem;
  box-shadow: rgb(0 0 0 / 15%) 2.4px 2.4px 3.2px;
`;

export const DivItem = styled.div`
  margin: 0.25rem 0;
  padding: 0 0.25rem;
  position: relative;
  a, button{
    display: flex;
    align-items: center;
    width: 100%;
    border: none;
    font-size: 0.82rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    transition: 300ms;
    user-select: none;
    background: transparent;
    color: var(--default-color-font);
    &:hover{
        background-color: var(--main-color);
        color: #FFF;
        svg{
          color: #FFF;
        }
    }
    svg{
        color: var(--default-color-font);
        margin: 0 0.5rem;
    }
    &[disabled]{
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
`;

export const MenuBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-top: 1px solid rgba(255,255,255, 0.2);
  padding: 0.25rem 0;
  width: 100%;
`;

export const DivProfilePic = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    >h3, h4{
        color: var(--default-color-font);
    }

    >label{
        position: absolute;
        width: 38px;
        height: 38px;
        background: var(--purple-lighter);
        border-radius: 50%;
        right: 30%;
        bottom: 20%;
        border: 0;
        transition: 200ms;
        cursor: pointer;
        display:none;
        align-items:center;
        justify-content:center;

        >input{
            display: none;
        }

        >svg{
            width: 26px;
            height: 26px;
            color: var(--grey-soft);  
            &:hover{
                color: #FFF;
            }
        }
    }

    &:hover{
        >label{
            display: flex;
        }
    }
`;

export const MediaQueryImg = `
  @media(max-width: 1280px){
    width: 48px;
    height: 48px;
  }
  @media(max-width: 800px){
    width: 38px;
    height: 38px;
  }
`;
